/*
 *
 * Api reducer
 *
 */

import produce from 'immer';
// import _ from 'lodash';

import {
  REQUEST_VEHICLES,
  REQUEST_VEHICLE,
  REQUEST_VEHICLE_PROPERTY_NAMES,
  REQUEST_VEHICLE_FILTER,
  UPDATE_VEHICLE_FILTERS,
  UPDATE_VEHICLE_SEARCH_STRING,
  SET_NEW_VEHICLE_VALUE,
  SET_NEW_VEHICLE,
  RETRIEVE_REGPLATE,
  INITIATE_VEHICLE_EDIT,
  INITIATE_VEHICLE_CREATE,
  INITIATE_NEW_ORDER_CREATE,
  SET_NEW_ORDER_VALUE,
  MMT,
  REQUEST_VEHICLE_OUTGOING_BPM_CALCULATION,
  ALL_OPTIONS,
  CALCULATE_PURCHASE_PRICES_BTW,
  CALCULATE_PURCHASE_PRICES_MARGE,
  HEXON_WEBSITES,
  HEXON_ADS_FOR,
  REQUEST_VEHICLE_PROPERTY_UPDATE,
  REQUEST_VEHICLE_PROPERTIES,
  REQUEST_VEHICLE_OPTIONS,
  REQUEST_VEHICLE_PROPERTY,
  REQUEST_VEHICLE_FILTER_RESET,
  ADD_VEHICLE_TO_BULK_ACTIONS_LIST,
  REMOVE_VEHICLE_FROM_BULK_ACTIONS_LIST,
  REMOVE_ALL_VEHICLE_FROM_BULK_ACTIONS_LIST,
  SET_VEHICLES_SORT,
  REQUEST_VEHICLE_TASKS,
  HEMEX_STATUS,
  HEXON_IMAGES_FOR,
  SILVERDAT_DATA,
  REQUEST_VEHICLE_PROPERTY_DELETE,
  SET_NEW_VEHICLE_OPTIONS,
  REQUEST_VEHICLES_DOCUMENTS_BY_TYPE,
  REQUEST_VEHICLE_HISTORY,
  UPDATE_HISTORY_FILTER,
  UPDATE_HISTORY_SEARCH_STRING,
} from './constants';

import { REQUEST_DATA_RESULT } from '../../containers/App/constants';
import { parseVehicle, parseVehicleTasks } from './helpers';
import { fixPriceFormat } from '../../utils/string';
import env from '../../env';
import { AppClientId } from '../Shared/constants';

const DEFAULT_FILTER = {
  searchString: null,
  offset: 0,
  properties: [],
  sortType: null,
  order: null,
};

export const initialState = {
  vehicles: [],
  vehiclesById: {},
  filter: {
    ...DEFAULT_FILTER,
  },
  vehicleTasks: [],
  vehicleBulkActionsList: [],
  bulkActionTask: null,
  vehicleCount: null,
  newVehicleOptions: null,
  paginator: {},
  propertyNames: null,
  newVehicle: {},
  newOrder: {},
  mmt: null,
  allOptions: {},
  hexonWebsites: [],
  hexonAds: {},
  hexonImages: {},
  vehicleProperties: {},
  silverdatData: {},
  hemexStatus: {},
  documents: {},
  historyLogs: [],
  filterHistoryLogs: {
    text: '',
    properties: [],
  },
};

const NEW_VEHICLE_PROPS = [
  'tax_type',
  'vehicle_purpose',
  'buying_contact',
  'brand_name',
  'model_name',
  'financial_price_b2c',
  'creditor_company',
  'creditor',
  'import',
  'vehicle_purpose',
  'sales_preferred_vehicle',
  'financial_purchase_price_marge_excl_bpm',
  'financial_purchase_price_excl_vat_excl_bpm',
  'financial_purchase_price_incl_vat_excl_bpm',
  'financial_purchase_price_incl_bpm_excl_btw',
  'financial_purchase_price_marge_bpm',
  'financial_purchase_price_marge_excl_bpm',
  'financial_purchase_price_incl_vat_bpm',
  'financial_purchase_price_excl_vat_excl_bpm',
  'transport',
  'brand_name_manual',
  'tax_type_manual',
  'transport_manual',
  'vehicle_purpose_manual',
  'locationAddressId',
];

export const vehicleReducer = (state = initialState, action) =>
  produce(state, draft => {
    switch (action?.id) {
      case REQUEST_VEHICLE_HISTORY:
        if (action?.result) {
          draft.historyLogs = action?.result?.items;
        }

        break;
    }
    switch (action.type) {
      case REQUEST_VEHICLE_PROPERTY_UPDATE:
        //
        break;
      case SET_NEW_VEHICLE_VALUE:
        if (action.initiate) {
          draft.newVehicle[action.name] = draft.newVehicle[action.name] || '';
        } else draft.newVehicle[action.name] = action.value;
        return;
      case SET_NEW_VEHICLE_OPTIONS:
        draft.newVehicleOptions = action.options;
        break;
      case SET_NEW_VEHICLE:
        let vehicle = action.data;
        // for (let  prop in vehicle){
        //   if (NEW_VEHICLE_PROPS.includes(prop)) draft.newVehicle[prop] = vehicle[prop];
        // }
        if (vehicle?.id) delete vehicle.id;
        if (vehicle?.properties) delete vehicle.properties;
        draft.newVehicle = action.reset ? { ...vehicle } : { ...draft.newVehicle, ...vehicle };
        break;
      case INITIATE_VEHICLE_CREATE:
        //only clear if there's an id
        if (draft.newVehicle.id) {
          draft.newVehicle = {};
        }
        break;
      case INITIATE_NEW_ORDER_CREATE:
        draft.newOrder = initialState.newOrder;
        break;
      case INITIATE_VEHICLE_EDIT:
        try {
          draft.newVehicle = {
            id: action.id,
          };

          let vehicle = draft.vehiclesById[action.id];

          if (vehicle) {
            vehicle.properties?.map(p => {
              if (p.propertyName.name == 'id') return null;
              draft.newVehicle[p.propertyName.name] = p.propertyValue.value;
              return null;
            });
          }
        } catch (e) {
          // eslint-disable-next-line no-debugger
          console.log(e);
        }
        break;
      case ADD_VEHICLE_TO_BULK_ACTIONS_LIST:
        if (!action.kanbanTaskName) {
          draft.bulkActionTask = null;
        }

        if (action?.vehicles?.length) {
          if (action?.kanbanTaskName && action?.kanbanTaskName !== draft.bulkActionTask) {
            draft.vehicleBulkActionsList = [];
            draft.bulkActionTask = action?.kanbanTaskName;
          }

          if (action?.page) {
            draft.vehicleBulkActionsList = {
              ...draft.vehicleBulkActionsList,
              [action?.page]: [...action.vehicles],
            };
            return;
          }
          draft.vehicleBulkActionsList = [...action.vehicles];
          return;
        }
        if (action?.payload) {
          if (action?.kanbanTaskName && action?.kanbanTaskName !== draft.bulkActionTask) {
            draft.vehicleBulkActionsList = [];
          }
          const isInList = draft.vehicleBulkActionsList?.[action?.page]?.filter(item => item?.id == action.payload?.id);

          if (action?.kanbanTaskName) {
            draft.bulkActionTask = action?.kanbanTaskName;
          }

          if (action?.page) {
            draft.vehicleBulkActionsList = !isInList?.length
              ? {
                  ...draft.vehicleBulkActionsList,
                  [action?.page]: [...(draft.vehicleBulkActionsList?.[action?.page] || []), action.payload],
                }
              : draft.vehicleBulkActionsList;
            return;
          }

          draft.vehicleBulkActionsList = !isInList?.length
            ? [...draft.vehicleBulkActionsList, action.payload]
            : draft.vehicleBulkActionsList;
        }
        return;
      case REMOVE_VEHICLE_FROM_BULK_ACTIONS_LIST:
        if (action.page && action?.vehicleId) {
          draft.vehicleBulkActionsList = {
            ...draft.vehicleBulkActionsList,
            [action?.page]: [...draft.vehicleBulkActionsList?.[action?.page].filter(item => item?.id != action?.vehicleId)],
          };

          return;
        }
        if (action?.vehicleId) {
          draft.vehicleBulkActionsList = draft.vehicleBulkActionsList.filter(item => item?.id != action?.vehicleId);
        }
        return;
      case REMOVE_ALL_VEHICLE_FROM_BULK_ACTIONS_LIST:
        if (action.page) {
          delete draft.vehicleBulkActionsList?.[action.page];
          return;
        }
        draft.vehicleBulkActionsList = [];
        return;
      case SET_NEW_ORDER_VALUE:
        if (action.initiate) {
          draft.newOrder[action.name] = draft.newOrder[action.name] || '';
        } else draft.newOrder[action.name] = action.value;
        return;
      case SET_VEHICLES_SORT:
        draft.filter.sortType = action.sortType;
        draft.filter.order = action.order;
        return;
      case UPDATE_VEHICLE_SEARCH_STRING:
        draft.filter.searchString = action.searchString || '';
        return;
      case UPDATE_VEHICLE_FILTERS:
      case REQUEST_VEHICLE_FILTER:
        if ('propertyFilter' in action) {
          if (action?.options?.skipFilter) {
            draft.filter.properties = [];
            draft.filter.properties.push(action.propertyFilter);
            return;
          }
          draft.filter.properties = draft.filter.properties
            .map(p => {
              if (p.key == action.propertyFilter?.key) return null;
              if (p.key == action.reset) return null;
              if (action.reset?.indexOf?.(p.key) > -1) {
                return null;
              }
              return p;
            })
            .filter(p => p);

          if (action.propertyFilter) draft.filter.properties.push(action.propertyFilter);
        }

        //clear empty values
        draft.filter.properties = draft.filter.properties.filter(p => p.value.length || p.value.id);

        if (action.name) {
          draft.filter[action.name] = action.value;
          //reset offset
        }
        if (action.name !== 'offset') draft.filter.offset = 0;
        break;
      case REQUEST_VEHICLE_FILTER_RESET:
        draft.filter = {
          ...DEFAULT_FILTER,
        };
        break;
      case REQUEST_DATA_RESULT:
        switch (action.id) {
          case REQUEST_VEHICLES:
            draft.vehicles = action.result.items.map(parseVehicle);
            draft.paginator = action.result.paginator;
            draft.vehicleCount = action.result.paginator.itemsCount;
            draft.vehicles.forEach(v => {
              if (!draft.vehiclesById[v.id]) draft.vehiclesById[v.id] = v;
            });
            break;
          case REQUEST_VEHICLE:
            try {
              draft.vehiclesById[action.vehicleId] = parseVehicle(action.result);
              console.dir(action.result);
              //   const index = draft.vehicles.findIndex(v => v.id === action.result.id);
              //   const vehicle = parseVehicle(action.result);
              //   if (index > -1) draft.vehicles[index] = vehicle;
              //   else draft.vehicles.push(vehicle);
            } catch (e) {
              console.error(e);
            }
            break;
          case REQUEST_VEHICLE_TASKS:
            try {
              draft.vehicleTasks = parseVehicleTasks(action?.result);
            } catch (e) {
              console.log(e);
            }
            break;
          case REQUEST_VEHICLE_PROPERTIES:
            try {
              if (!(action.vehicleId in draft.vehiclesById))
                draft.vehiclesById[action.vehicleId] = {
                  id: action.vehicleId,
                  properties: [],
                };
              draft.vehiclesById[action.vehicleId].properties = action.result;
              draft.vehiclesById[action.vehicleId].props = null;
              draft.vehiclesById[action.vehicleId] = parseVehicle(draft.vehiclesById[action.vehicleId]);
            } catch (e) {
              console.error(e);
              // eslint-disable-next-line no-debugger
              debugger;
            }
            break;
          case REQUEST_VEHICLE_PROPERTY_DELETE:
            try {
              if (action.propertyName != 'id') {
                delete draft.vehiclesById[action.vehicleId][action.propertyName];
              }
            } catch (error) {
              //
            }
            break;
          case REQUEST_VEHICLE_PROPERTY:
            if (!(action.vehicleId in draft.vehicleProperties)) draft.vehicleProperties[action.vehicleId] = {};
            draft.vehicleProperties[action.vehicleId][action.propertyName] = action.result?.data ? null : action.result;
            break;

          case REQUEST_VEHICLE_OPTIONS:
            try {
              draft.vehiclesById[action.vehicleId].options = action.result;
            } catch (e) {
              console.error(e);
              // eslint-disable-next-line no-debugger
              debugger;
            }
            break;
          case REQUEST_VEHICLE_PROPERTY_NAMES:
            draft.propertyNames = action.result;
            break;
          case MMT:
            draft.mmt = action.result;
            break;
          case ALL_OPTIONS:
            draft.allOptions = action.result;
            break;
          case REQUEST_VEHICLE_OUTGOING_BPM_CALCULATION:
            draft.outgoingBpmCalculation = action.result;
            break;
          case HEXON_WEBSITES:
            draft.hexonWebsites = action.result.results;
            break;
          case HEXON_ADS_FOR:
            draft.hexonAds[action.vehicle_id] = action.result.results;
            break;
          case HEXON_IMAGES_FOR:
            draft.hexonImages[action.vehicle_id] = action.result.results;
            break;
          case CALCULATE_PURCHASE_PRICES_BTW:
            draft.newVehicle.financial_purchase_price_incl_vat_bpm =
              fixPriceFormat(action?.result?.financial_purchase_price_incl_vat_bpm) ?? null;
            draft.newVehicle.financial_purchase_price_incl_vat_excl_bpm =
              fixPriceFormat(action?.result?.financial_purchase_price_incl_vat_excl_bpm) ?? null;
            draft.newVehicle.financial_purchase_price_excl_vat_excl_bpm =
              fixPriceFormat(action?.result?.financial_purchase_price_excl_vat_excl_bpm) ?? null;
            draft.newVehicle.financial_purchase_price_incl_bpm_excl_btw =
              fixPriceFormat(action?.result?.financial_purchase_price_incl_bpm_excl_btw) ?? null;
            draft.newVehicle.vat_percentage = fixPriceFormat(action?.result?.vat_percentage) ?? null;
            draft.newVehicle.vat_amount = fixPriceFormat(action?.result?.vat_amount) ?? null;
            draft.newVehicle.rest_bpm = fixPriceFormat(action?.result?.rest_bpm) ?? null;
            draft.newVehicle.financial_bpm_gross = fixPriceFormat(action?.result?.financial_bpm_gross) ?? null;

            if (env.clientId === AppClientId.AUTOWIENTJES) {
              draft.newVehicle.economic_prize = fixPriceFormat(action?.result?.economic_prize) ?? null;
              draft.newVehicle.valuation_price = fixPriceFormat(action?.result?.valuation_price) ?? null;
            }
            break;
          case CALCULATE_PURCHASE_PRICES_MARGE:
            draft.newVehicle.financial_purchase_price_marge_bpm = fixPriceFormat(
              action?.result?.financial_purchase_price_marge_bpm,
            );
            draft.newVehicle.financial_purchase_price_marge_excl_bpm =
              fixPriceFormat(action?.result?.financial_purchase_price_marge_excl_bpm) ?? null;
            draft.newVehicle.rest_bpm = fixPriceFormat(action?.result?.rest_bpm) ?? null;
            draft.newVehicle.financial_bpm_gross = fixPriceFormat(action?.result?.financial_bpm_gross) ?? null;
            if (env.clientId === AppClientId.AUTOWIENTJES) {
              draft.newVehicle.economic_prize = fixPriceFormat(action?.result?.economic_prize) ?? null;
              draft.newVehicle.valuation_price = fixPriceFormat(action?.result?.valuation_price) ?? null;
            }
            break;
          case RETRIEVE_REGPLATE:
            let v = action.result?.items?.length ? parseVehicle(action.result?.items[0]) : {};
            delete v.id;
            delete v.properties;
            draft.newVehicle = v;
            break;
          case HEMEX_STATUS:
            draft.hemexStatus[action.vehicleId] = action.result;
            break;
          case SILVERDAT_DATA:
            debugger;
            draft.silverdatData[action.vehicleId] = action.result;
            break;
          case REQUEST_VEHICLES_DOCUMENTS_BY_TYPE:
            draft.documents = { ...draft.documents, ...action.result };
            break;
        }
        break;
      case UPDATE_HISTORY_SEARCH_STRING:
        draft.filterHistoryLogs.text = action?.text;
        break;
      case UPDATE_HISTORY_FILTER:
        draft.filterHistoryLogs.properties = action?.properties;
        break;
    }
  });
